import { render, staticRenderFns } from "./App.vue?vue&type=template&id=31ad00d8&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=31ad00d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad00d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/khm-grippeimpftag/khm-grippeimpftag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('31ad00d8', component.options)
    } else {
      api.reload('31ad00d8', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=31ad00d8&scoped=true&", function () {
      api.rerender('31ad00d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/src/App.vue"
export default component.exports